import React from "react";
import styles from "./DialogModel.module.css";

const DialogModel = ({ title, message, setModelData }: any) => {
  return (
    <>
      <div
        className={styles.darkBG}
        onClick={() => setModelData({ isOpen: false })}
      />
      <div className={styles.centered}>
        <div className={styles.modal}>
          <div className={styles.modalHeader}>
            <h5 className={styles.heading}>{title}</h5>
          </div>

          <div className={styles.modalContent}>{message}</div>
          <div className={styles.modalActions}>
            <div className={styles.actionsContainer}>
              <button
                className={styles.deleteBtn}
                // onClick={() => setIsOpen(false)}
                onClick={() => setModelData({ isOpen: false })}
              >
                Okay
              </button>
              {/* <button
                className={styles.cancelBtn}
                // onClick={() => setIsOpen(false)}
              >
                Cancel
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DialogModel;
